import {
  GUARDAR_SUSCRIPCION_PLACA,
  GUARDAR_SUSCRIPCION_PLACA_ERROR,
  GUARDAR_SUSCRIPCION_PLACA_SUCCESS,
  PLACAS_ACTIVAS_LISTAR,
  PLACAS_ACTIVAS_LISTAR_ERROR,
  PLACAS_ACTIVAS_LISTAR_SUCCESS,
  PLANES_ACTIVOS_LISTAR,
  PLANES_ACTIVOS_LISTAR_ERROR,
  PLANES_ACTIVOS_LISTAR_SUCCESS,
  SUSCRIPCION_PLACA_LISTAR,
  SUSCRIPCION_PLACA_LISTAR_ERROR,
  SUSCRIPCION_PLACA_LISTAR_SUCCESS
} from "./SuscripcionPlacaActions";

const initialState = {
  isActivityIndicatorShown: false,
  documentos: [],
  perfiles: [],
  suscripcionPlaca: [],
  paginacion: {
    limite: 5,
    actual: 1,
    filtro: undefined,
    orden: "id",
    sentido: "ASC",
  },
};

const suscripcionPlacaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUSCRIPCION_PLACA_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case SUSCRIPCION_PLACA_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        suscripcionPlaca: action.respuestaServidor.suscripcionPlaca,
        paginacion: action.respuestaServidor.paginacion,
      };
    case SUSCRIPCION_PLACA_LISTAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    case PLACAS_ACTIVAS_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };

    case PLACAS_ACTIVAS_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        placas: action.respuestaServidor.placas,
      };
      case PLACAS_ACTIVAS_LISTAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
      case PLANES_ACTIVOS_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
      case PLANES_ACTIVOS_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        plan: action.respuestaServidor.plan,
      };
      case PLANES_ACTIVOS_LISTAR_ERROR:
        return {
          ...state,
          isActivityIndicatorShown: false,
        };
      
    case GUARDAR_SUSCRIPCION_PLACA:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GUARDAR_SUSCRIPCION_PLACA_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    case GUARDAR_SUSCRIPCION_PLACA_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };


    default:
      return state;
  }
};

export default suscripcionPlacaReducer;
